import createReducer from 'legacy/src/shared/util/createReducer';
import { ACTIONS } from '../utils/constants';
import { doImpersonate } from './actions';

const {
  SET_READ_ONLY,
  SET_STUDENT_ID,
  SET_SECTION_ID,
  SET_IMPERSONATOR_EDUCATION_PERIOD,
  SET_IMPERSONATOR_TEACHER_CLASSES,
  SET_IMPERSONATOR_TEACHER_SUBJECTS,
  SET_IMPERSONATOR_TEACHER_NAV,
  SET_IMPERSONATOR_SUBJECT,
  SET_IMPERSONATOR_CURRENT_SUBJECT,
  SET_IS_WELCOME_VIDEO_FIRST_TIME,
} = ACTIONS;

const initialState = {
  isReadOnly: false,
  teacherSubjects: [],
  isWelcomeVideoFirstTime: false,
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  const {
    isReadOnly,
    studentId,
    sectionId,
    educationPeriod,
    teacherClasses,
    teacherSubjects,
    teacherNav,
    subject,
    isWelcomeVideoFirstTime,
    currentSubject,
  } = payload || {};

  switch (type) {
    case SET_READ_ONLY:
      return {
        ...state,
        isReadOnly,
      };
    case SET_STUDENT_ID:
      return {
        ...state,
        studentId,
      };
    case SET_SECTION_ID:
      return {
        ...state,
        sectionId,
      };
    case SET_IMPERSONATOR_EDUCATION_PERIOD:
      return {
        ...state,
        educationPeriod,
      };
    case SET_IMPERSONATOR_TEACHER_CLASSES:
      return {
        ...state,
        teacherClasses,
      };
    case SET_IMPERSONATOR_TEACHER_SUBJECTS:
      return {
        ...state,
        teacherSubjects,
      };
    case SET_IMPERSONATOR_TEACHER_NAV:
      return {
        ...state,
        teacherNav,
      };
    case SET_IMPERSONATOR_SUBJECT:
      return {
        ...state,
        subject,
      };
    case SET_IMPERSONATOR_CURRENT_SUBJECT:
      return {
        ...state,
        currentSubject,
      };
    case SET_IS_WELCOME_VIDEO_FIRST_TIME:
      return {
        ...state,
        isWelcomeVideoFirstTime,
      };
    default:
      return state;
  }
};

const sagaInitialState = {
  loadingImpersonating: false,
};

export const sagaReducer = createReducer(sagaInitialState, {
  [doImpersonate.request]: (state) => ({
    ...state,
    loadingImpersonating: true,
  }),
  [doImpersonate.success]: (state, { payload }) => {
    return {
      ...state,
      ...payload,
      loadingImpersonating: false,
    };
  },
  [doImpersonate.failure]: (state) => ({
    ...state,
    loadingImpersonating: false,
  }),
});

export default reducer;
